import * as React from "react";

export default function SearchInput(props) {
  return (
   <input className="SearchBar" onChange={props.onchange} value={props.value} type={props.type} placeholder={props.placeholder}/>
  );
}
